import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Bracket, BracketMatch } from '../../model/tournament';

@Component({
  selector: 'app-tournament-bracket',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tournament-bracket.component.html',
  styleUrl: './tournament-bracket.component.css',
})
export class TournamentBracketComponent {
  @Input() bracket: Bracket | null = null;
  @Input() organizer = false;
  @Output() matchSelected = new EventEmitter<BracketMatch>();

  // Matches grouped by round, ascending (round 1 = first round ... N = final), each round sorted by slot.
  get rounds(): BracketMatch[][] {
    const matches = this.bracket?.matches ?? [];
    const byRound = new Map<number, BracketMatch[]>();
    for (const m of matches) {
      const list = byRound.get(m.round) ?? [];
      list.push(m);
      byRound.set(m.round, list);
    }
    return Array.from(byRound.keys())
      .sort((a, b) => a - b)
      .map(r => byRound.get(r)!.sort((a, b) => a.slot - b.slot));
  }

  roundLabel(round: number): string {
    const total = this.rounds.length;
    const fromEnd = total - round; // 0 = final, 1 = semis, 2 = quarters
    if (fromEnd === 0) return 'Final';
    if (fromEnd === 1) return 'Semifinals';
    if (fromEnd === 2) return 'Quarterfinals';
    return `Round ${round}`;
  }

  isPlayable(m: BracketMatch): boolean {
    return !!m.team_a_id && !!m.team_b_id && !m.winner_team_id;
  }

  teamLabel(name: string | null, teamId: number | null): string {
    if (teamId == null) return 'Bye';
    return name || 'TBD';
  }

  onMatchClick(m: BracketMatch): void {
    if (this.organizer && this.isPlayable(m)) {
      this.matchSelected.emit(m);
    }
  }
}
